namespace SorAraBul.PropertyManagement {
    export interface TenantDetailHasoStartRequest extends Serenity.ServiceRequest {
        EntityId?: string;
        Entity?: TenantDetailRow;
    }
}
